<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h2a"><a id="page_5">CONTENTS</a></h1><a id="page_5">
</a><h2 class="toc-chap1"><a id="page_5"></a><a href="#/xhtml/04_Acknowledgements"><em class="italic">Acknowledgements</em></a></h2>
<h2 class="toc-chap"><a href="#/xhtml/06_Preface"><em class="italic">Preface</em></a></h2>
<h2 class="toc-chap"><a href="#/xhtml/08_Chapter_01"><span class="toc-chap_float">Chapter 1</span> Ogmore Branch – Tondu to Nantymoel</a></h2>
<h2 class="toc-chap"><span href="#/xhtml/09_Chapter_02" title="Link target outside of Sample"><span class="toc-chap_float">Chapter 2</span> Garw Branch – Brynmenyn to Blaengarw</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/10_Chapter_03" title="Link target outside of Sample"><span class="toc-chap_float">Chapter 3</span> Porthcawl Branch – Tondu to Porthcawl</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/11_Chapter_04" title="Link target outside of Sample"><span class="toc-chap_float">Chapter 4</span> Gilfach Goch Branch</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/12_Chapter_05" title="Link target outside of Sample"><span class="toc-chap_float">Chapter 5</span> Llanharan Branch</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/13_Chapter_06" title="Link target outside of Sample"><span class="toc-chap_float">Chapter 6</span> Enthusiast Specials</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/14_Chapter_07" title="Link target outside of Sample"><span class="toc-chap_float">Chapter 7</span> Main Line Diversions</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/15_Chapter_08" title="Link target outside of Sample"><span class="toc-chap_float">Chapter 8</span> Chronologies</span></h2>
<h2 class="toc-chaps"><span href="#/xhtml/15_Chapter_08#ch08_s1" title="Link target outside of Sample">Saturday 7 July 1962 Tondu to Porthcawl</span></h2>
<h2 class="toc-chaps"><span href="#/xhtml/15_Chapter_08#ch08_s2" title="Link target outside of Sample">Saturday 3 May 1958 Last Passenger Services to Nantymoel</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?bbc7c254